var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.758 7.402c2.187 0 3.992 1.778 3.992 3.965v.793c0 2.188-1.805 3.965-3.992 3.992a3.98 3.98 0 0 1-2.79-1.175L12 13.007l-1.996 1.97a3.954 3.954 0 0 1-2.79 1.148A3.968 3.968 0 0 1 3.25 12.16v-.793c0-2.187 1.777-3.965 3.965-3.992 1.039 0 2.05.438 2.789 1.176L12 10.52l1.969-1.97a3.953 3.953 0 0 1 2.789-1.148Zm-7.985 6.344 1.97-1.969-1.97-1.996a2.214 2.214 0 0 0-1.558-.629c-1.23 0-2.215.985-2.215 2.215v.793c0 1.23.984 2.215 2.215 2.242.574 0 1.148-.246 1.558-.656ZM19 12.16v-.793c0-1.23-1.012-2.242-2.242-2.215-.574 0-1.149.22-1.559.63l-1.969 1.995 1.97 1.97c.41.41.984.655 1.558.655A2.252 2.252 0 0 0 19 12.16Z"
  })));
};

export default SvgInfinity;